import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { RootState } from "../../store";
import { setSavedKpiPreferencesData } from "../../reducers/savedKpiPreferences";
import { PreferenceDetails, SavedDataView } from "./savedKpiPreferencesAPI.types";

export type SavedViewResponse = {
  viewId: string;
  value: SavedDataView;
};

const emptyPreferences = (): PreferenceDetails => ({ savedDataViews: {} });

export const savedKpiPreferencesAPI = createApi({
  reducerPath: "savedKpiPreferencesAPI",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["SavedKpiPreferences"],
  endpoints: (builder) => ({
    getSavedKpiPreference: builder.query<SavedViewResponse | undefined, string>({
      query: (viewId) => ({ url: `/abo-enrichment/api/saved-view?${new URLSearchParams({ ViewID: viewId })}` }),
      transformResponse: (response: SavedViewResponse | undefined) => response,
      providesTags: (_result, _error, viewId) => [{ type: "SavedKpiPreferences", id: viewId }],
      async onQueryStarted(viewId, { dispatch, getState, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data) return;
          const current =
            (getState() as RootState).savedKpiPreferencesData.savedKpiPreferencesData ?? emptyPreferences();
          dispatch(
            setSavedKpiPreferencesData({
              ...current,
              savedDataViews: { ...current.savedDataViews, [viewId]: data.value },
            }),
          );
        } catch {
          // Consumers retain their configured defaults when a saved view is unavailable.
        }
      },
    }),
    updateSavedKpiPreference: builder.mutation<SavedViewResponse, { viewId: string; value: SavedDataView }>({
      query: ({ viewId, value }) => ({
        url: "/abo-enrichment/api/saved-view",
        method: "PUT",
        body: { viewId, value },
      }),
      invalidatesTags: (_result, _error, { viewId }) => [{ type: "SavedKpiPreferences", id: viewId }],
    }),
  }),
});

export const { useGetSavedKpiPreferenceQuery, useUpdateSavedKpiPreferenceMutation } = savedKpiPreferencesAPI;
